export default ({ redirect, store }) => {
  const authed = store.getters['auth/authed']

  if (authed) {
    redirect('/')
  }
}
